import React from 'react'

export default function Chip({
  children,
  size = 'md',
  className,
}: {
  children: React.ReactNode
  size?: 'sm' | 'md'
  className?: string
}): React.ReactNode {
  return (
    <span
      className={`bg-lightBlue text-darkBlue rounded-lg ${size === 'sm' ? 'py-1 px-2 text-sm' : 'py-2 px-4'} flex flex-row gap-2 justify-center ${className ?? ''}`}
    >
      {children}
    </span>
  )
}
